<template>
  <section class="content">
    <mai-modal v-if="modal && active" @close="modal = false" :title="active.name">
      <params
        slot="content"
        v-if="active"
        :parentId="active.id"
        :filename="active.filename"
        :crud="false"
        ref="docParams"
      />
      <div slot="footer">
        <div class="btn btn-primary sq" @click="$refs.docParams.go()">
          Generate
        </div>
        <div class="btn btn-danger sq" @click="modal = false">
          Close
        </div>
      </div>
    </mai-modal>
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :show-edit="allowEditAndDelete"
      :show-delete="allowEditAndDelete"
      :has-slot="true"
      :table-data="tableData"
      :table-title="'Reports'"
      :fields="[{ header: 'Name', prop: 'name', hideByDefault: false }, { header: 'Code', prop: 'code', hideByDefault: false }]"
      v-on:pages-remaining="loadMore"
      :max-items="maxValue"
    >
      <div slot="icons" slot-scope="maiScope" class="btn btn-primary" data-toggle="tooltip" title="Download" @click="popup(maiScope.item)">
        <i class="fa fa-download"></i>
      </div>
    </vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  import MaiModal from '../../../../components/MaiModal.vue'
  import Params from './ReportParameters'
  export default {
    name: 'ReportSearchResults',
    components: {
      vuetable: vuetable,
      Loader,
      MaiModal,
      Params
    },
    mixins: [ AdminSearchResults ],
    computed: {
      role () {
        return this.$store.getters['authentication/role']
      },
      allowEditAndDelete () {
        return this.role && this.role.code && this.role.code.startsWith('ADMIN')
      }
    },
    data () {
      return {
        loading: false,
        tableData: [],
        entityName: 'document',
        editEntityScreen: 'Admin - Edit/View Report',
        modal: false,
        active: null
      }
    },
    methods: {
      popup (item) {
        this.active = item
        this.modal = true
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// ReportSearchResults.vue?5a905358